module.exports = __webpack_public_path__ + "static/media/estado-financiero-consultar.229ad468.png";